import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./IOTServices.css";

import iotrobotic from "../../assests/iot-robotic.svg"
import heroImg from "../../assests/Background-img.svg";

// Components
import ARVRSecondpage from "../Ar-vrServicespage/ARVRSecondpage";

import ContactFormModal from "../header/ContactFormModal";
import CoreServices from "../coreServices/coreServices";
import BusinessValue from "../BusinessValue/BusinessValue";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import ArBusiness from "../Ar-vrServicespage/ArBusiness";
import { useNavigate } from "react-router-dom";
// Define service type  
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const IOTServices: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("ar");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="iot-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="hero-section-iot d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-iot text-center">
    <h1 className="hero-title-iot">IoT & Robotic Automation</h1>
    <p className="hero-subtitle-iot">
         Connect, automate, and monitor operations with cutting-edge IoT and RPA solutions.
    </p>
    <button
      className=" hero-button-iot"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>

      {/* Other Sections */}
      <CoreServices/>
      <BusinessValue/>
      <WhyIOTSection/>
      <ArBusiness/>
    </div>
  );
};

export default IOTServices;
